import htmlComponent from 'htmlcomponent'

export default function(dom, opts) {
	let options = {
		...opts
	};

	const listItem = dom.closest('.nav-main__nav-item');
	const list = listItem.parentNode;
	const index = [].slice.call(list.childNodes, 0).indexOf(listItem);
	const subList = listItem.querySelector('.nav-main__nav-item-subnav');
	const openClass = 'submenu--open';

	const toggleItem = (toggle) => {
		subList.addEventListener('transitionend', e => {
			subList.style.maxHeight = '';
		}, { once: true });

		subList.style.maxHeight = `${subList.scrollHeight}px`;
		setTimeout(() => {
			listItem.classList.toggle(openClass, toggle);
		}, 1);
	};

	htmlComponent.listen('submenu:open', (e, data) => {
		if (data.index !== index) {
			// close other elements?
			// htmlComponent.send('submenu:close', {index});
		}
		else {
			toggleItem(true);
		}
	});

	htmlComponent.listen('submenu:close', (e, data) => {
		if (data.index === index) {
			toggleItem(false);
		}
	});

	dom.addEventListener('click', e => {
		if (window.innerWidth >= 1024) {
			return;
		}

		e.preventDefault();

		if (listItem.classList.contains(openClass)) {
			htmlComponent.send('submenu:close', {index});
		}
		else {
			htmlComponent.send('submenu:open', {index});
		}
	});
}